::ng-deep particle-edit-report{display:flex;flex-grow:1}
/*# sourceMappingURL=edit-report.component-VY4EWC3K.css.map */
